module.exports = __webpack_public_path__ + "img/a8789c3.jpg";